
import React from "react";
import ProjectTemplate from "../components/ProjectTemplate";

const ClubcrisisPage = () => {
  const media = 
  [
    '/images/dashdashdash_2.webp', 
    '/images/dashdashdash.webp', 
  ];

  return (
    <div className="clubcrisis-page">
      <ProjectTemplate
        title="club crisis"
        year="2021"
        sections={[
          {
            type: "description",
            text: 'Club Crisis is a collective work with Marthe Naessens and Anders Herrebaut which focusses on nightlife. We deal with the absence of intimate social events, exploring past remembrances of going out and expressing these club experiences in new shapes and forms. Club Crisis deals with personal anecdotes and stories, which are brought to life for an audience through a multidisciplinary approach. Different elements are combined to form a multi-media totality in which visitors can wander, lose themselves and be absorbed in the atmosphere. The audience is activated by being in the space, resonating with the club feeling. In times of Covid-19 and loneliness in isolation, we look for alternative ways to lose ourselves in the moment.', 
          },
          {
            type: "video",
            links: 
            [    
              "https://www.youtube.com/embed/lW0-r43m0zQ?si=mrsU-qSHfALFy3C6?controls=1&modestbranding=1&showinfo=0",
            ],
          }, 
        ]}
      />
    </div>
  );
};

export default ClubcrisisPage;
